import { z } from "@/zod";
import { dateTime, ulid } from "@/schemas/commonFields";
import { createContractorVisit } from "@/schemas/contractorVisit";
import { time } from "@/schemas/commonFields/time";

const visitEntrySchema = z
  .object({
    start_datetime: z.preprocess(
      (val) => (val === "" ? null : val),
      dateTime.nullish(),
    ),
    end_datetime: z.preprocess(
      (val) => (val === "" ? null : val),
      dateTime.nullish(),
    ),
    suggested_start_time: z.preprocess(
      (val) => (val === "" ? null : val),
      time.nullable(),
    ),
    suggested_end_time: z.preprocess(
      (val) => (val === "" ? null : val),
      time.nullable(),
    ),
    pr_planned_duration: z.preprocess(
      (val) => (val === "" ? null : val),
      z.string().nullable(),
    ),
  })
  .superRefine((data, ctx) => {
    const { start_datetime, end_datetime } = data;

    const allDefined = start_datetime !== null && end_datetime !== null;

    const noneDefined = start_datetime === null && end_datetime === null;

    if (allDefined || noneDefined) {
      return;
    }

    ctx.addIssue({
      code: "custom",
      path: ["start_datetime"],
    });
    ctx.addIssue({
      code: "custom",
      path: ["end_datetime"],
    });
  });

export const ContractorVisitsEditorDirectoryFormSchema = z.object({
  entries: z.record(ulid, visitEntrySchema.optional()),
});

export const CreateContractorVisitFormSchema = createContractorVisit.extend({
  project_id: ulid,
});
